export default {
  "home": {
    "header": {
      "openFull": "Open full view",
      "settings": "Home settings",
      "show": "Show header",
      "hide": "Hide header"
    },
    "empty": {
      "admin": {
        "badge": "Org admins only",
        "title": "Choose what {workspaceName} sees first",
        "body": "Home is the first page everyone in this workspace lands on. Pick one of its AI dashboards to show here. You can change it any time in Settings.",
        "cta": "Select a home layout",
        "settings": "Home settings"
      },
      "member": {
        "title": "Home isn't set up yet",
        "body": "An org admin chooses the dashboard shown here. In the meantime, every dashboard you have access to is one click away.",
        "cta": "Browse dashboards"
      },
      "missing": {
        "title": "The Home dashboard is no longer available"
      }
    },
    "picker": {
      "title": "Choose the Home dashboard for {workspaceName}",
      "desc": "Everyone in this workspace lands on this dashboard. Other workspaces keep their own Home.",
      "search": "Search AI dashboards",
      "empty": "No AI dashboards in this workspace yet.",
      "noThumbnail": "Preview pending",
      "updated": "Updated {date}",
      "note": "Only AI dashboards from this workspace are listed.",
      "cancel": "Cancel",
      "confirm": "Set as Home"
    },
    "layoutTag": "Home layout",
    "saved": "Home dashboard updated",
    "cleared": "Home dashboard cleared"
  }
};
